import _get from 'lodash/get';
import { updateIsWidgetExpanded } from './index';
import wix from '../services/wix';
import { ANIMATION_TIMEOUTS } from '../constants/animation-timeouts';
import { EDITOR_VIEW_MODE } from '../constants/editor-view-mode';
import { isExperimentOn } from '../reducers';
import { Experiments } from '../constants/experiments';

export const expandWidget = () => {
  return async function (dispatch, getState) {
    const viewMode = wix.getViewMode();
    const editorViewModes =
      viewMode === EDITOR_VIEW_MODE.EDITOR ||
      viewMode === EDITOR_VIEW_MODE.PREVIEW;

    const expandInEditorXMobileEditorFT = isExperimentOn(
      getState(),
      Experiments.ExpandInMobileResponsiveEditor,
    );

    if (
      !expandInEditorXMobileEditorFT &&
      editorViewModes &&
      wix.isMobileDevice()
    ) {
      return;
    }

    if (await wix.isResponsiveMobile()) {
      await wix.resizeToExpandedModeMobileResponsive();
    } else {
      await wix.resizeToExpandedMode();
    }
    dispatch(updateIsWidgetExpanded(true));
  };
};

export const collapseWidget = (withMessageNotification = false) => {
  return async function (dispatch, getState) {
    dispatch(updateIsWidgetExpanded(false));
    if (await wix.isResponsiveMobile()) {
      wix.hideMobileComponent();
      return wix.resizeToCollapsedMode(true);
    }
    setTimeout(async () => {
      if (withMessageNotification) {
        return wix.resizeToCollapsedWithMessageNotification();
      }
      const asRounded = _get(
        getState().editorSettingsLayout,
        'collapsedAsRounded',
        false,
      );
      return wix.resizeToCollapsedMode(asRounded);
    }, ANIMATION_TIMEOUTS.COLLAPSE);
  };
};
